'use client';
import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';


import Image from 'next/image';

import type { HousingPropertyDetail } from '@eliadmin/core/src/api/housing/housing-types';

import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

export function HousingTabAttributes({ housing }: { housing: HousingPropertyDetail }) {
  const { t } = useTranslations();

  return (
    <div className="flex w-full flex-col items-start justify-start gap-6 sm:gap-8 lg:gap-12">
      <div className="flex w-full flex-col items-start justify-start gap-4 sm:gap-5 lg:gap-6">
        <h4 className="text-2xl font-bold tracking-tight text-secondary sm:text-3xl lg:text-[32px]">
          {t('text1399')}
        </h4>
        <div className="flex w-full flex-wrap items-start justify-start gap-2 sm:gap-3">
          {housing?.rooms[0]?.values?.map(value => (
            <div
              key={value.name}
              className="flex h-[40px] w-fit items-center justify-start gap-2 whitespace-nowrap rounded-full border bg-white px-4 text-sm font-bold tracking-tight text-secondary sm:h-[50px] sm:px-5 sm:text-base lg:px-6"
            >
              <Image
                src={value?.image?.url ?? ''}
                alt={resolveImageAlt(value?.image, value?.name)}
                width={20}
                height={20}
                className="max-h-5 min-h-5 min-w-5 max-w-5 shrink-0 object-contain"
              />
              {value.name}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
